import { factory } from "../../../../utils/apiThunkFactory";

export const fetchReservations = factory.get("myEventModal/fetchReservations", "/api/bookings/get");
export const fetchUpcomingCount = factory.get("myEventModal/fetchUpcomingCount","/api/bookings/countUpcoming");
